import React, { useContext } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import TeachersList from "../Page/TeacherList/TeachersList";
import Header from "../Component/Header/Header";
import Teacher from "../Page/Teacher/Teacher";
import Invoice from "../Page/Invoice/Invoice";
import Login from "../Page/Login/Login";
import Wrapper from "../UIcomponent/Wrapper";
import Profile from "../Component/Profile/Profile";
import LocalContext from "../Context/LocalContetxt";
import Lessons from "../Component/Lessons/Lessons";
import Register from "../Page/Register/Register";
import Landing from "../Page/Landing";
import TeacherLanding from "../Page/TeacherLanding";
import PaymentStatus from "../Page/PaymentStatus";
import FirstVoucher from "../Component/FirstVoucher";
import Footer from "../Component/Footer";
import NotFound from "../Page/NotFound";
import { RoutePath } from "../Utility/RoutePath";
import FooterDescription from "../Component/FooterDescription";
import NotificationBar from "../Component/Banner";
import PrivateRoute from "./PrivateRoute";
import StudentDashboard from "../Page/Dashboard/StudentDashboard";
import TeacherDashboard from "../Page/Dashboard/TeacherDashboard";

const hasNotification = false;

const Routing = (prop) => {
  const config = useContext(LocalContext).config;
  const hasToken = useContext(LocalContext).hasToken;

  return (
    <>
      <BrowserRouter basename="/">
        <FirstVoucher hasToken={hasToken} />
        {hasNotification ? <NotificationBar /> : null}

        <Header {...prop} />
        <Switch>
          <Route
            path="/"
            exact
            component={(props) =>
              hasToken ? <Redirect to="/teachers" /> : <Landing {...props} />
            }
          />
          <Route
            path="/jointeacher"
            exact
            component={(props) => <TeacherLanding {...props} />}
          />
          <Route
            path="/*"
            component={(props) => (
              <>
                <Wrapper>
                  <Switch>
                    <Route
                      path="/teacher-list"
                      exact
                      component={(props) => <TeachersList {...props} />}
                    />
                    <Route
                      path="/login"
                      exact
                      component={(props) =>
                        hasToken ? (
                          <Redirect to="/dashboard" />
                        ) : (
                          <Login {...props} />
                        )
                      }
                    />
                    <Route
                      path="/register/teacher"
                      exact
                      component={(props) => <Register {...props} />}
                    />
                    <PrivateRoute path={RoutePath.studentDashboard}>
                      {config?.role === "Teacher" ? (
                        <TeacherDashboard />
                      ) : (
                        <StudentDashboard />
                      )}
                    </PrivateRoute>
                    <Route
                      exact
                      path={RoutePath.lessons}
                      component={(props) =>
                        !config || !hasToken ? (
                          <Redirect
                            to={{
                              pathname: "/login",
                              state: { from: props.location },
                            }}
                          />
                        ) : (
                          <Lessons />
                        )
                      }
                    />
                    <Route
                      path="/profile"
                      component={(props) => <Profile {...props} />}
                    />
                    <Route
                      path="/teachers"
                      exact
                      component={(props) => <TeachersList {...props} />}
                    />
                    <Route
                      path="/teacher/:id"
                      exact
                      component={(props) => <Teacher {...props} />}
                    />
                    <Route
                      path="/invoice"
                      exact
                      component={(props) =>
                        !hasToken ? (
                          <Redirect
                            to={{
                              pathname: "/login",
                              state: { from: props.location },
                            }}
                          />
                        ) : (
                          <Invoice {...props} />
                        )
                      }
                    />
                    <Route
                      path="/payment-success"
                      exact
                      component={(props) =>
                        !hasToken ? (
                          <Redirect
                            to={{
                              pathname: "/login",
                              state: { from: props.location },
                            }}
                          />
                        ) : (
                          <PaymentStatus payStatus={1} {...props} />
                        )
                      }
                    />
                    <Route
                      path="/payment-fail"
                      exact
                      component={(props) =>
                        !hasToken ? (
                          <Redirect
                            to={{
                              pathname: "/login",
                              state: { from: props.location },
                            }}
                          />
                        ) : (
                          <PaymentStatus payStatus={-1} {...props} />
                        )
                      }
                    />
                    <Route component={() => <NotFound />} />
                  </Switch>
                </Wrapper>
              </>
            )}
          />
        </Switch>
        <FooterDescription />
        <Footer />
      </BrowserRouter>
    </>
  );
};

export default Routing;
